// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file assistant/v1/assistant.proto (package assistant.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file assistant/v1/assistant.proto.
 */
export const file_assistant_v1_assistant: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_types]);

/**
 * Chat represents a conversation session between a user and the chatbot
 *
 * @generated from message assistant.v1.Chat
 */
export type Chat = Message<"assistant.v1.Chat"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID agent_id = 2;
   */
  agentId?: ID;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: assistant.v1.ChatStatus status = 4;
   */
  status: ChatStatus;

  /**
   * @generated from field: types.ID user_id = 5;
   */
  userId?: ID;

  /**
   * @generated from field: types.Base base = 6;
   */
  base?: Base;

  /**
   * @generated from field: repeated assistant.v1.ChatMessage messages = 7;
   */
  messages: ChatMessage[];
};

/**
 * Describes the message assistant.v1.Chat.
 * Use `create(ChatSchema)` to create a new message.
 */
export const ChatSchema: GenMessage<Chat> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 0);

/**
 * TextPart represents a text content part
 *
 * @generated from message assistant.v1.TextPart
 */
export type TextPart = Message<"assistant.v1.TextPart"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * "Streaming" or "Done"
   *
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 3;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.TextPart.
 * Use `create(TextPartSchema)` to create a new message.
 */
export const TextPartSchema: GenMessage<TextPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 1);

/**
 * ReasoningPart represents a reasoning/thinking content part
 *
 * @generated from message assistant.v1.ReasoningPart
 */
export type ReasoningPart = Message<"assistant.v1.ReasoningPart"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * "Streaming" or "Done"
   *
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 3;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.ReasoningPart.
 * Use `create(ReasoningPartSchema)` to create a new message.
 */
export const ReasoningPartSchema: GenMessage<ReasoningPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 2);

/**
 * ToolCallPart represents a tool invocation
 *
 * @generated from message assistant.v1.ToolCallPart
 */
export type ToolCallPart = Message<"assistant.v1.ToolCallPart"> & {
  /**
   * @generated from field: string tool_call_id = 1;
   */
  toolCallId: string;

  /**
   * @generated from field: string tool_name = 2;
   */
  toolName: string;

  /**
   * @generated from field: assistant.v1.ToolCallState tool_call_state = 3;
   */
  toolCallState: ToolCallState;

  /**
   * @generated from field: google.protobuf.Struct input = 4;
   */
  input?: JsonObject;

  /**
   * @generated from field: google.protobuf.Struct output = 5;
   */
  output?: JsonObject;

  /**
   * @generated from field: string error_text = 6;
   */
  errorText: string;

  /**
   * @generated from field: bool provider_executed = 7;
   */
  providerExecuted: boolean;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 8;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.ToolCallPart.
 * Use `create(ToolCallPartSchema)` to create a new message.
 */
export const ToolCallPartSchema: GenMessage<ToolCallPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 3);

/**
 * DynamicToolPart represents a dynamic tool invocation (runtime-defined tools)
 *
 * @generated from message assistant.v1.DynamicToolPart
 */
export type DynamicToolPart = Message<"assistant.v1.DynamicToolPart"> & {
  /**
   * @generated from field: string tool_call_id = 1;
   */
  toolCallId: string;

  /**
   * @generated from field: string tool_name = 2;
   */
  toolName: string;

  /**
   * @generated from field: assistant.v1.ToolCallState tool_call_state = 3;
   */
  toolCallState: ToolCallState;

  /**
   * @generated from field: google.protobuf.Struct input = 4;
   */
  input?: JsonObject;

  /**
   * @generated from field: google.protobuf.Struct output = 5;
   */
  output?: JsonObject;

  /**
   * @generated from field: string error_text = 6;
   */
  errorText: string;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 7;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.DynamicToolPart.
 * Use `create(DynamicToolPartSchema)` to create a new message.
 */
export const DynamicToolPartSchema: GenMessage<DynamicToolPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 4);

/**
 * SourceUrlPart represents a URL source reference
 *
 * @generated from message assistant.v1.SourceUrlPart
 */
export type SourceUrlPart = Message<"assistant.v1.SourceUrlPart"> & {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 4;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.SourceUrlPart.
 * Use `create(SourceUrlPartSchema)` to create a new message.
 */
export const SourceUrlPartSchema: GenMessage<SourceUrlPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 5);

/**
 * SourceDocumentPart represents a document source reference
 *
 * @generated from message assistant.v1.SourceDocumentPart
 */
export type SourceDocumentPart = Message<"assistant.v1.SourceDocumentPart"> & {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId: string;

  /**
   * IANA media type
   *
   * @generated from field: string media_type = 2;
   */
  mediaType: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string filename = 4;
   */
  filename: string;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 5;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.SourceDocumentPart.
 * Use `create(SourceDocumentPartSchema)` to create a new message.
 */
export const SourceDocumentPartSchema: GenMessage<SourceDocumentPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 6);

/**
 * FilePart represents a file attachment
 *
 * @generated from message assistant.v1.FilePart
 */
export type FilePart = Message<"assistant.v1.FilePart"> & {
  /**
   * IANA media type
   *
   * @generated from field: string media_type = 1;
   */
  mediaType: string;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Struct provider_metadata = 4;
   */
  providerMetadata?: JsonObject;
};

/**
 * Describes the message assistant.v1.FilePart.
 * Use `create(FilePartSchema)` to create a new message.
 */
export const FilePartSchema: GenMessage<FilePart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 7);

/**
 * DataPart represents custom application data
 *
 * @generated from message assistant.v1.DataPart
 */
export type DataPart = Message<"assistant.v1.DataPart"> & {
  /**
   * For data-{name} types
   *
   * @generated from field: string data_type = 1;
   */
  dataType: string;

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject;
};

/**
 * Describes the message assistant.v1.DataPart.
 * Use `create(DataPartSchema)` to create a new message.
 */
export const DataPartSchema: GenMessage<DataPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 8);

/**
 * StepStartPart represents a step boundary marker
 *
 * Empty marker for step boundaries
 *
 * @generated from message assistant.v1.StepStartPart
 */
export type StepStartPart = Message<"assistant.v1.StepStartPart"> & {
};

/**
 * Describes the message assistant.v1.StepStartPart.
 * Use `create(StepStartPartSchema)` to create a new message.
 */
export const StepStartPartSchema: GenMessage<StepStartPart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 9);

/**
 * ChatMessagePart represents a single part of a message using union types
 * Aligned with AI SDK UIMessagePart discriminated union structure
 *
 * @generated from message assistant.v1.ChatMessagePart
 */
export type ChatMessagePart = Message<"assistant.v1.ChatMessagePart"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID message_id = 2;
   */
  messageId?: ID;

  /**
   * @generated from field: int32 sequence = 3;
   */
  sequence: number;

  /**
   * Union of all possible part types
   *
   * @generated from oneof assistant.v1.ChatMessagePart.part_data
   */
  partData: {
    /**
     * @generated from field: assistant.v1.TextPart text = 4;
     */
    value: TextPart;
    case: "text";
  } | {
    /**
     * @generated from field: assistant.v1.ReasoningPart reasoning = 5;
     */
    value: ReasoningPart;
    case: "reasoning";
  } | {
    /**
     * @generated from field: assistant.v1.ToolCallPart tool_call = 6;
     */
    value: ToolCallPart;
    case: "toolCall";
  } | {
    /**
     * @generated from field: assistant.v1.DynamicToolPart dynamic_tool = 7;
     */
    value: DynamicToolPart;
    case: "dynamicTool";
  } | {
    /**
     * @generated from field: assistant.v1.SourceUrlPart source_url = 8;
     */
    value: SourceUrlPart;
    case: "sourceUrl";
  } | {
    /**
     * @generated from field: assistant.v1.SourceDocumentPart source_document = 9;
     */
    value: SourceDocumentPart;
    case: "sourceDocument";
  } | {
    /**
     * @generated from field: assistant.v1.FilePart file = 10;
     */
    value: FilePart;
    case: "file";
  } | {
    /**
     * @generated from field: assistant.v1.DataPart data = 11;
     */
    value: DataPart;
    case: "data";
  } | {
    /**
     * @generated from field: assistant.v1.StepStartPart step_start = 12;
     */
    value: StepStartPart;
    case: "stepStart";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message assistant.v1.ChatMessagePart.
 * Use `create(ChatMessagePartSchema)` to create a new message.
 */
export const ChatMessagePartSchema: GenMessage<ChatMessagePart> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 10);

/**
 * ChatMessage represents a single message in a chat conversation
 * Follows AI SDK UIMessage structure with parts-based content
 *
 * @generated from message assistant.v1.ChatMessage
 */
export type ChatMessage = Message<"assistant.v1.ChatMessage"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID chat_id = 2;
   */
  chatId?: ID;

  /**
   * @generated from field: assistant.v1.ChatMessageRole role = 3;
   */
  role: ChatMessageRole;

  /**
   * Message content as parts array (aligned with AI SDK UIMessage)
   *
   * @generated from field: repeated assistant.v1.ChatMessagePart parts = 4;
   */
  parts: ChatMessagePart[];

  /**
   * Multi-agent support
   *
   * @generated from field: types.ID agent_id = 5;
   */
  agentId?: ID;

  /**
   * Custom metadata
   *
   * @generated from field: google.protobuf.Struct metadata = 6;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: types.ID organization_id = 7;
   */
  organizationId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message assistant.v1.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 11);

/**
 * Agent represents an AI agent configuration
 *
 * @generated from message assistant.v1.Agent
 */
export type Agent = Message<"assistant.v1.Agent"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: assistant.v1.AgentType type = 3;
   */
  type: AgentType;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: string agent_identifier = 7;
   */
  agentIdentifier: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: types.ID created_by = 9;
   */
  createdBy?: ID;

  /**
   * @generated from field: types.ID organization_id = 10;
   */
  organizationId?: ID;

  /**
   * @generated from field: types.Base base = 11;
   */
  base?: Base;

  /**
   * @generated from field: repeated string tool_ids = 12;
   */
  toolIds: string[];

  /**
   * AI Model Configuration
   *
   * @generated from field: assistant.v1.ModelProvider model_provider = 13;
   */
  modelProvider: ModelProvider;

  /**
   * @generated from field: string model = 14;
   */
  model: string;

  /**
   * @generated from field: string provider_base_url = 15;
   */
  providerBaseUrl: string;

  /**
   * @generated from field: string provider_api_key = 16;
   */
  providerApiKey: string;

  /**
   * @generated from field: bool reasoning_enabled = 17;
   */
  reasoningEnabled: boolean;

  /**
   * @generated from field: int32 reasoning_budget = 18;
   */
  reasoningBudget: number;

  /**
   * @generated from field: float temperature = 19;
   */
  temperature: number;
};

/**
 * Describes the message assistant.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 12);

/**
 * @generated from message assistant.v1.AgentFilter
 */
export type AgentFilter = Message<"assistant.v1.AgentFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;

  /**
   * @generated from field: assistant.v1.AgentType type = 3;
   */
  type: AgentType;

  /**
   * @generated from field: types.ID organization_id = 4;
   */
  organizationId?: ID;

  /**
   * @generated from field: string search_term = 5;
   */
  searchTerm: string;

  /**
   * @generated from field: string agent_identifier = 6;
   */
  agentIdentifier: string;

  /**
   * @generated from field: repeated types.ID created_by = 7;
   */
  createdBy: ID[];

  /**
   * @generated from field: repeated types.ID updated_by = 8;
   */
  updatedBy: ID[];
};

/**
 * Describes the message assistant.v1.AgentFilter.
 * Use `create(AgentFilterSchema)` to create a new message.
 */
export const AgentFilterSchema: GenMessage<AgentFilter> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 13);

/**
 * @generated from message assistant.v1.CreateAgentInput
 */
export type CreateAgentInput = Message<"assistant.v1.CreateAgentInput"> & {
  /**
   * @generated from field: types.ID id = 16;
   */
  id?: ID;

  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: assistant.v1.AgentType type = 4;
   */
  type: AgentType;

  /**
   * @generated from field: string agent_identifier = 5;
   */
  agentIdentifier: string;

  /**
   * @generated from field: types.ID organization_id = 6;
   */
  organizationId?: ID;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * @generated from field: types.ID created_by = 8;
   */
  createdBy?: ID;

  /**
   * AI Model Configuration
   *
   * @generated from field: assistant.v1.ModelProvider model_provider = 9;
   */
  modelProvider: ModelProvider;

  /**
   * @generated from field: string model = 10;
   */
  model: string;

  /**
   * @generated from field: string provider_api_key = 11;
   */
  providerApiKey: string;

  /**
   * @generated from field: string provider_base_url = 12;
   */
  providerBaseUrl: string;

  /**
   * @generated from field: bool reasoning_enabled = 13;
   */
  reasoningEnabled: boolean;

  /**
   * @generated from field: int32 reasoning_budget = 14;
   */
  reasoningBudget: number;

  /**
   * @generated from field: float temperature = 15;
   */
  temperature: number;
};

/**
 * Describes the message assistant.v1.CreateAgentInput.
 * Use `create(CreateAgentInputSchema)` to create a new message.
 */
export const CreateAgentInputSchema: GenMessage<CreateAgentInput> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 14);

/**
 * @generated from message assistant.v1.UpdateAgentInput
 */
export type UpdateAgentInput = Message<"assistant.v1.UpdateAgentInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: assistant.v1.AgentType type = 4;
   */
  type: AgentType;

  /**
   * @generated from field: string agent_identifier = 5;
   */
  agentIdentifier: string;

  /**
   * @generated from field: types.ID organization_id = 6;
   */
  organizationId?: ID;

  /**
   * AI Model Configuration
   *
   * @generated from field: assistant.v1.ModelProvider model_provider = 7;
   */
  modelProvider: ModelProvider;

  /**
   * @generated from field: string model = 8;
   */
  model: string;

  /**
   * @generated from field: string provider_api_key = 9;
   */
  providerApiKey: string;

  /**
   * @generated from field: string provider_base_url = 10;
   */
  providerBaseUrl: string;

  /**
   * @generated from field: bool reasoning_enabled = 11;
   */
  reasoningEnabled: boolean;

  /**
   * @generated from field: int32 reasoning_budget = 12;
   */
  reasoningBudget: number;

  /**
   * @generated from field: float temperature = 13;
   */
  temperature: number;
};

/**
 * Describes the message assistant.v1.UpdateAgentInput.
 * Use `create(UpdateAgentInputSchema)` to create a new message.
 */
export const UpdateAgentInputSchema: GenMessage<UpdateAgentInput> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 15);

/**
 * @generated from message assistant.v1.SetAgentToolsInput
 */
export type SetAgentToolsInput = Message<"assistant.v1.SetAgentToolsInput"> & {
  /**
   * @generated from field: repeated string tool_ids = 1;
   */
  toolIds: string[];
};

/**
 * Describes the message assistant.v1.SetAgentToolsInput.
 * Use `create(SetAgentToolsInputSchema)` to create a new message.
 */
export const SetAgentToolsInputSchema: GenMessage<SetAgentToolsInput> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 16);

/**
 * @generated from message assistant.v1.ListAgentsRequest
 */
export type ListAgentsRequest = Message<"assistant.v1.ListAgentsRequest"> & {
  /**
   * @generated from field: assistant.v1.AgentFilter filter = 1;
   */
  filter?: AgentFilter;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * Describes the message assistant.v1.ListAgentsRequest.
 * Use `create(ListAgentsRequestSchema)` to create a new message.
 */
export const ListAgentsRequestSchema: GenMessage<ListAgentsRequest> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 17);

/**
 * @generated from message assistant.v1.ListAgentsResponse
 */
export type ListAgentsResponse = Message<"assistant.v1.ListAgentsResponse"> & {
  /**
   * @generated from field: repeated assistant.v1.Agent agents = 1;
   */
  agents: Agent[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message assistant.v1.ListAgentsResponse.
 * Use `create(ListAgentsResponseSchema)` to create a new message.
 */
export const ListAgentsResponseSchema: GenMessage<ListAgentsResponse> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 18);

/**
 * @generated from message assistant.v1.GetAgentRequest
 */
export type GetAgentRequest = Message<"assistant.v1.GetAgentRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message assistant.v1.GetAgentRequest.
 * Use `create(GetAgentRequestSchema)` to create a new message.
 */
export const GetAgentRequestSchema: GenMessage<GetAgentRequest> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 19);

/**
 * @generated from message assistant.v1.GetAgentResponse
 */
export type GetAgentResponse = Message<"assistant.v1.GetAgentResponse"> & {
  /**
   * @generated from field: assistant.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message assistant.v1.GetAgentResponse.
 * Use `create(GetAgentResponseSchema)` to create a new message.
 */
export const GetAgentResponseSchema: GenMessage<GetAgentResponse> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 20);

/**
 * @generated from message assistant.v1.CreateAgentRequest
 */
export type CreateAgentRequest = Message<"assistant.v1.CreateAgentRequest"> & {
  /**
   * @generated from field: assistant.v1.CreateAgentInput input = 1;
   */
  input?: CreateAgentInput;
};

/**
 * Describes the message assistant.v1.CreateAgentRequest.
 * Use `create(CreateAgentRequestSchema)` to create a new message.
 */
export const CreateAgentRequestSchema: GenMessage<CreateAgentRequest> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 21);

/**
 * @generated from message assistant.v1.CreateAgentResponse
 */
export type CreateAgentResponse = Message<"assistant.v1.CreateAgentResponse"> & {
  /**
   * @generated from field: assistant.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message assistant.v1.CreateAgentResponse.
 * Use `create(CreateAgentResponseSchema)` to create a new message.
 */
export const CreateAgentResponseSchema: GenMessage<CreateAgentResponse> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 22);

/**
 * @generated from message assistant.v1.UpdateAgentRequest
 */
export type UpdateAgentRequest = Message<"assistant.v1.UpdateAgentRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: assistant.v1.UpdateAgentInput input = 2;
   */
  input?: UpdateAgentInput;
};

/**
 * Describes the message assistant.v1.UpdateAgentRequest.
 * Use `create(UpdateAgentRequestSchema)` to create a new message.
 */
export const UpdateAgentRequestSchema: GenMessage<UpdateAgentRequest> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 23);

/**
 * @generated from message assistant.v1.UpdateAgentResponse
 */
export type UpdateAgentResponse = Message<"assistant.v1.UpdateAgentResponse"> & {
  /**
   * @generated from field: assistant.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message assistant.v1.UpdateAgentResponse.
 * Use `create(UpdateAgentResponseSchema)` to create a new message.
 */
export const UpdateAgentResponseSchema: GenMessage<UpdateAgentResponse> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 24);

/**
 * @generated from message assistant.v1.ActivateAgentRequest
 */
export type ActivateAgentRequest = Message<"assistant.v1.ActivateAgentRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message assistant.v1.ActivateAgentRequest.
 * Use `create(ActivateAgentRequestSchema)` to create a new message.
 */
export const ActivateAgentRequestSchema: GenMessage<ActivateAgentRequest> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 25);

/**
 * @generated from message assistant.v1.ActivateAgentResponse
 */
export type ActivateAgentResponse = Message<"assistant.v1.ActivateAgentResponse"> & {
  /**
   * @generated from field: assistant.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message assistant.v1.ActivateAgentResponse.
 * Use `create(ActivateAgentResponseSchema)` to create a new message.
 */
export const ActivateAgentResponseSchema: GenMessage<ActivateAgentResponse> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 26);

/**
 * @generated from message assistant.v1.SetAgentToolsRequest
 */
export type SetAgentToolsRequest = Message<"assistant.v1.SetAgentToolsRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: assistant.v1.SetAgentToolsInput input = 2;
   */
  input?: SetAgentToolsInput;
};

/**
 * Describes the message assistant.v1.SetAgentToolsRequest.
 * Use `create(SetAgentToolsRequestSchema)` to create a new message.
 */
export const SetAgentToolsRequestSchema: GenMessage<SetAgentToolsRequest> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 27);

/**
 * @generated from message assistant.v1.SetAgentToolsResponse
 */
export type SetAgentToolsResponse = Message<"assistant.v1.SetAgentToolsResponse"> & {
  /**
   * @generated from field: assistant.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message assistant.v1.SetAgentToolsResponse.
 * Use `create(SetAgentToolsResponseSchema)` to create a new message.
 */
export const SetAgentToolsResponseSchema: GenMessage<SetAgentToolsResponse> = /*@__PURE__*/
  messageDesc(file_assistant_v1_assistant, 28);

/**
 * ChatStatus represents the state of a chat session
 *
 * @generated from enum assistant.v1.ChatStatus
 */
export enum ChatStatus {
  /**
   * @generated from enum value: CHAT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHAT_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: CHAT_STATUS_ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * Describes the enum assistant.v1.ChatStatus.
 */
export const ChatStatusSchema: GenEnum<ChatStatus> = /*@__PURE__*/
  enumDesc(file_assistant_v1_assistant, 0);

/**
 * ChatMessageRole represents the role of who sent the message
 *
 * @generated from enum assistant.v1.ChatMessageRole
 */
export enum ChatMessageRole {
  /**
   * @generated from enum value: CHAT_MESSAGE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHAT_MESSAGE_ROLE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: CHAT_MESSAGE_ROLE_ASSISTANT = 2;
   */
  ASSISTANT = 2,

  /**
   * @generated from enum value: CHAT_MESSAGE_ROLE_SYSTEM = 3;
   */
  SYSTEM = 3,
}

/**
 * Describes the enum assistant.v1.ChatMessageRole.
 */
export const ChatMessageRoleSchema: GenEnum<ChatMessageRole> = /*@__PURE__*/
  enumDesc(file_assistant_v1_assistant, 1);

/**
 * ToolCallState represents the state of a tool call (aligned with AI SDK)
 *
 * @generated from enum assistant.v1.ToolCallState
 */
export enum ToolCallState {
  /**
   * @generated from enum value: TOOL_CALL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOOL_CALL_STATE_INPUT_STREAMING = 1;
   */
  INPUT_STREAMING = 1,

  /**
   * @generated from enum value: TOOL_CALL_STATE_INPUT_AVAILABLE = 2;
   */
  INPUT_AVAILABLE = 2,

  /**
   * @generated from enum value: TOOL_CALL_STATE_OUTPUT_AVAILABLE = 3;
   */
  OUTPUT_AVAILABLE = 3,

  /**
   * @generated from enum value: TOOL_CALL_STATE_OUTPUT_ERROR = 4;
   */
  OUTPUT_ERROR = 4,
}

/**
 * Describes the enum assistant.v1.ToolCallState.
 */
export const ToolCallStateSchema: GenEnum<ToolCallState> = /*@__PURE__*/
  enumDesc(file_assistant_v1_assistant, 2);

/**
 * AgentType represents the type of agent
 *
 * @generated from enum assistant.v1.AgentType
 */
export enum AgentType {
  /**
   * @generated from enum value: AGENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Global orchestrator agent
   *
   * @generated from enum value: AGENT_TYPE_AGENT = 1;
   */
  AGENT = 1,

  /**
   * Specialized sub-agent
   *
   * @generated from enum value: AGENT_TYPE_SUBAGENT = 2;
   */
  SUBAGENT = 2,

  /**
   * File/document/image preprocessing agent
   *
   * @generated from enum value: AGENT_TYPE_FILE_PROCESSOR = 3;
   */
  FILE_PROCESSOR = 3,
}

/**
 * Describes the enum assistant.v1.AgentType.
 */
export const AgentTypeSchema: GenEnum<AgentType> = /*@__PURE__*/
  enumDesc(file_assistant_v1_assistant, 3);

/**
 * ModelProvider represents the LLM provider
 *
 * @generated from enum assistant.v1.ModelProvider
 */
export enum ModelProvider {
  /**
   * @generated from enum value: MODEL_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODEL_PROVIDER_GEMINI = 1;
   */
  GEMINI = 1,

  /**
   * @generated from enum value: MODEL_PROVIDER_OPENAI = 2;
   */
  OPENAI = 2,

  /**
   * @generated from enum value: MODEL_PROVIDER_ANTHROPIC = 3;
   */
  ANTHROPIC = 3,

  /**
   * @generated from enum value: MODEL_PROVIDER_CEREBRAS = 4;
   */
  CEREBRAS = 4,
}

/**
 * Describes the enum assistant.v1.ModelProvider.
 */
export const ModelProviderSchema: GenEnum<ModelProvider> = /*@__PURE__*/
  enumDesc(file_assistant_v1_assistant, 4);

/**
 * @generated from service assistant.v1.AssistantQueriesService
 */
export const AssistantQueriesService: GenService<{
  /**
   * @generated from rpc assistant.v1.AssistantQueriesService.ListAgents
   */
  listAgents: {
    methodKind: "unary";
    input: typeof ListAgentsRequestSchema;
    output: typeof ListAgentsResponseSchema;
  },
  /**
   * @generated from rpc assistant.v1.AssistantQueriesService.GetAgent
   */
  getAgent: {
    methodKind: "unary";
    input: typeof GetAgentRequestSchema;
    output: typeof GetAgentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_assistant_v1_assistant, 0);

/**
 * @generated from service assistant.v1.AssistantCommandsService
 */
export const AssistantCommandsService: GenService<{
  /**
   * @generated from rpc assistant.v1.AssistantCommandsService.CreateAgent
   */
  createAgent: {
    methodKind: "unary";
    input: typeof CreateAgentRequestSchema;
    output: typeof CreateAgentResponseSchema;
  },
  /**
   * @generated from rpc assistant.v1.AssistantCommandsService.UpdateAgent
   */
  updateAgent: {
    methodKind: "unary";
    input: typeof UpdateAgentRequestSchema;
    output: typeof UpdateAgentResponseSchema;
  },
  /**
   * @generated from rpc assistant.v1.AssistantCommandsService.ActivateAgent
   */
  activateAgent: {
    methodKind: "unary";
    input: typeof ActivateAgentRequestSchema;
    output: typeof ActivateAgentResponseSchema;
  },
  /**
   * @generated from rpc assistant.v1.AssistantCommandsService.SetAgentTools
   */
  setAgentTools: {
    methodKind: "unary";
    input: typeof SetAgentToolsRequestSchema;
    output: typeof SetAgentToolsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_assistant_v1_assistant, 1);

